import React from 'react'

import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'
import ServiceCapabilities from '../services/ServiceCapabilities'

const ForwardDeployedEngineers = ({ lang }) => {
  const { fde } = getEnterpriseAIContent(lang)
  const tabs = fde.capabilities.map(cap => ({
    id: cap.id,
    label: cap.label,
    paragraphs: [cap.body],
  }))

  return (
    <section className="enterprise-ai-fde" aria-labelledby="enterprise-ai-fde-heading">
      <div className="content container">
        <div className="enterprise-ai-fde__intro">
          <h2 id="enterprise-ai-fde-heading" className="enterprise-ai-fde__heading">
            {fde.heading}
          </h2>
          <p className="enterprise-ai-fde__lede">{fde.lede}</p>
        </div>
        <ServiceCapabilities
          nested
          showHeading={false}
          tabs={tabs}
          defaultActiveId={fde.defaultCapabilityId}
          idBase="enterprise-ai-fde-capabilities"
        />
      </div>
    </section>
  )
}

export default ForwardDeployedEngineers
